export enum EWifiActions {
    FETCH_WIFI = '@wi-fi/wi-fi_points/fetch',
    SET_WIFI = '@wi-fi/wi-fi_points/set',
    ERROR_WIFI = '@wi-fi/wi-fi_points/fetching_error',

    CHANGE_CONTACT = '@wi-fi/change/contact',
    CHANGE_CATEGORY = '@wi-fi/change/category',
}
